export default "__VITE_ASSET__BEQB_wtv__"